module.exports = __webpack_public_path__ + "img/woman.16edfe1d.png";